import { Addon }   from 'Models/UI/Addon';
import { Payload } from 'Models/UI/Payload';

export class PayloadAddons implements Payload {
    addons : Addon[];
}